<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
    <rect x="3.5" y="14" width="36" height="62" rx="2" ry="2" fill="#fff" stroke="#6576ff" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" />
    <line x1="3.5" y1="22" x2="39.5" y2="22" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
    <line x1="3.5" y1="64" x2="39.5" y2="64" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
    <line x1="20.5" y1="18" x2="25.5" y2="18" fill="none" stroke="#c4cefe" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" />
    <line x1="17.17" y1="18" x2="17.17" y2="18" fill="none" stroke="#c4cefe" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" />
    <circle cx="21.5" cy="70" r="2" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
    <rect x="7.5" y="25" width="28" height="35" fill="#eff1ff" />
    <rect x="10.5" y="40" width="4" height="6" rx="2" ry="2" fill="#c4cefe" />
    <rect x="16.5" y="40" width="4" height="6" rx="2" ry="2" fill="#c4cefe" />
    <rect x="22.5" y="40" width="4" height="6" rx="2" ry="2" fill="#c4cefe" />
    <rect x="28.5" y="40" width="4" height="6" rx="2" ry="2" fill="#c4cefe" />
    <rect x="50.5" y="14" width="36" height="62" rx="2" ry="2" fill="#fff" stroke="#6576ff" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" />
    <line x1="50.5" y1="22" x2="86.5" y2="22" fill="none" stroke="#6576ff" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" />
    <line x1="50.5" y1="64" x2="86.5" y2="64" fill="none" stroke="#6576ff" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" />
    <line x1="67.5" y1="18" x2="72.5" y2="18" fill="none" stroke="#c4cefe" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" />
    <line x1="64.45" y1="17.86" x2="64.45" y2="17.86" fill="none" stroke="#c4cefe" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" />
    <circle cx="68.5" cy="70" r="2" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
    <rect x="54.5" y="25" width="28" height="35" fill="#eff1ff" />
    <rect x="57.5" y="39" width="4" height="6" rx="2" ry="2" fill="#c4cefe" />
    <rect x="63.5" y="39" width="4" height="6" rx="2" ry="2" fill="#c4cefe" />
    <rect x="69.5" y="39" width="4" height="6" rx="2" ry="2" fill="#c4cefe" />
    <rect x="75.5" y="39" width="4" height="6" rx="2" ry="2" fill="#c4cefe" />
    <ellipse cx="45.51" cy="44" rx="15.18" ry="15" fill="#fff" stroke="#6576ff" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" />
    <ellipse cx="45.51" cy="44" rx="11.13" ry="11" fill="#e3e7fe" />
    <path d="M46,50.92s5.5-2.77,5.5-6.92V39.16L46,37.08l-5.5,2.08V44C40.5,48.15,46,50.92,46,50.92Z" fill="#6576ff" />
    <polyline points="48.04 42 44.56 46 42.98 44.18" fill="none" stroke="#fff" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" />
</svg>